import { checkLocalhost } from '@src/api/ngApiClient/utils';

/**
 * Регулярка проверки корректности, что строка это валидный урл
 */
const pattern = new RegExp(
  '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$',
  'i',
); // fragment locator
/**
 * Функция для экстернал редиректов
 * @param url строка для преобразования в урл
 */
export const push = (url: string) => {
  try {
    if (typeof url !== 'string' || url.length < 1) return false;
    if (window === undefined) {
      console.error('window is undefined');
      return false;
    }
    if (pattern.test(url) || checkLocalhost(new URL(url))) {
      if (window.location.href === url) {
        window.location.reload();
      } else {
        window.location.href = url;
      }
    }
  } catch (err) {
    throw err;
  }
};
